module.exports = __webpack_public_path__ + "static/media/carta_8.b56ca092.jpg";